import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface AlertButton {
  text: string;
  value?: any;
  primary?: boolean;
}

export interface AlertPopupData {
  message: string;
  type: 'success' | 'error' | 'warning';
  buttons?: AlertButton[];
}

/**
 * Generic alert popup component for displaying success, error, and warning messages
 * 
 * @example
 * // Simple success message with default OK button
 * this.popupService.openAlert('User created successfully', 'success');
 * 
 * @example
 * // Error message with custom buttons
 * const dialogRef = this.popupService.openAlert(
 *   'Are you sure you want to delete?',
 *   'warning',
 *   [
 *     { text: 'Cancel', value: 'cancel' },
 *     { text: 'Delete', value: 'delete', primary: true }
 *   ]
 * );
 * dialogRef.afterClosed().subscribe(result => {
 *   if (result === 'delete') {
 *     // Perform deletion
 *   }
 * });
 */
@Component({
  selector: 'app-alert-popup',
  templateUrl: './alert-popup.component.html',
  styleUrls: ['./alert-popup.component.scss']
})
export class AlertPopupComponent implements OnInit {
  defaultButtons: AlertButton[] = [{ text: 'Ok, Thanks', value: 'ok', primary: true }];

  constructor(
    private dialogRef: MatDialogRef<AlertPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AlertPopupData
  ) {}

  ngOnInit(): void {
    // Set default buttons if none provided
    if (!this.data.buttons || this.data.buttons.length === 0) {
      this.data.buttons = this.defaultButtons;
    }
  }

  onButtonClick(button: AlertButton): void {
    this.dialogRef.close(button.value !== undefined ? button.value : button.text);
  }
}
